import { Box } from "@bca/ui-library";
import styled from "styled-components";

export const KeyDecisionMakerText = styled(Box)<{ smallerGap?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: ${(props) => (props.smallerGap ? "2px" : "6px")};
  align-items: center;
`;
